/* eslint-disable no-underscore-dangle */

// eslint-disable-next-line no-undef, @web-platform/custom-linting/use-saddlebag-browser
__webpack_public_path__ = window.__ASSET_PATH;
